'use strict'

import Blockly from 'blockly'

export const gtaMsgHans = (path = `/projects/base/helpdocument`) => {
  /**事件类别的积木跳转配置*/

console.log('path--',path)

  Blockly.Msg[`gta_ai_event_1`] = `${path}?menu=Events#gta_ai_event_1`
  Blockly.Msg[`gta_ai_event_2`] = `${path}?menu=Events#gta_ai_event_2`
  Blockly.Msg[`gta_ai_event_3`] = `${path}?menu=Events#gta_ai_event_3`
  Blockly.Msg[`gta_ai_event_4`] = `${path}?menu=Events#gta_ai_event_4`
  Blockly.Msg[`gta_ai_event_5`] = `${path}?menu=Events#gta_ai_event_5`
  Blockly.Msg[`gta_ai_event_6`] = `${path}?menu=Events#gta_ai_event_6`
  Blockly.Msg[`gta_ai_event_print`] = `${path}?menu=Events#gta_ai_event_print`
  Blockly.Msg[`gta_ai_event_7`] = `${path}?menu=Events#gta_ai_event_7`
  Blockly.Msg[`gta_ai_event_8`] = `${path}?menu=Events#gta_ai_event_8`
  Blockly.Msg[`gta_ai_event_9`] = `${path}?menu=Events#gta_ai_event_9`
  Blockly.Msg[`gta_ai_event_9`] = `${path}?menu=Events#gta_ai_event_9`
  Blockly.Msg[`gta_ai_event_10`] = `${path}?menu=Events#gta_ai_event_10`
  Blockly.Msg[`gta_ai_event_11`] = `${path}?menu=Events#gta_ai_event_11`
  Blockly.Msg[`gta_ai_event_12`] = `${path}?menu=Events#gta_ai_event_12`

  // controls_repeat_ext
  Blockly.Msg[
    `CONTROLS_REPEAT_HELPURL`
  ] = `${path}?menu=Control#controls_repeat_ext`

  // gta_controls_whileUntil
  Blockly.Msg[
    `GTA_CONTROLS_WHILEUNTIL_HELPURL`
  ] = `${path}?menu=Control#gta_controls_whileUntil`
  // export const GTA_CONTROLS_WHILEUNTIL_HELPURL =
  //     `${path}?menu=Control#2`

  // controls_for
  Blockly.Msg[`CONTROLS_FOR_HELPURL`] = `${path}?menu=Control#controls_for`

  // controls_forEach
  Blockly.Msg[
    `CONTROLS_FOREACH_HELPURL`
  ] = `${path}?menu=Control#controls_forEach`

  // break_continue
  Blockly.Msg[`BREAK_CONTINUE_HELPURL`] = `${path}?menu=Control#break_continue`

  // controls_if
  Blockly.Msg[`CONTROLS_IF_HELPURL`] = `${path}?menu=Control#controls_if`

  // logic_negate
  Blockly.Msg[`LOGIC_NEGATE_HELPURL`] = `${path}?menu=Control#logic_negate`

  // logic_ternary
  Blockly.Msg[`LOGIC_TERNARY_HELPURL`] = `${path}?menu=Control#logic_ternary`

  // waiting_time
  Blockly.Msg[`WAITING_TIME_HELPURL`] = `${path}?menu=Control#waiting_time`

  // 运算类别的积木跳转配置
  // math_number
  Blockly.Msg[`MATH_NUMBER_HELPURL`] = `${path}?menu=Operators#math_number`

  // math_arithmetic_add
  Blockly.Msg[
    `MATH_ARITHMETIC_ADD_HELPURL`
  ] = `${path}?menu=Operators#math_arithmetic_add`

  // logic_compare_1
  Blockly.Msg[
    `LOGIC_COMPARE_1_HELPURL`
  ] = `${path}?menu=Operators#logic_compare_1`

  // logic_operation
  Blockly.Msg[
    `LOGIC_OPERATION_HELPURL`
  ] = `${path}?menu=Operators#logic_operation`

  // logic_boolean
  Blockly.Msg[`LOGIC_BOOLEAN_HELPURL`] = `${path}?menu=Operators#logic_boolean`

  // math_random_int
  Blockly.Msg[
    `MATH_RANDOM_INT_HELPURL`
  ] = `${path}?menu=Operators#math_random_int`

  // math_modulo
  Blockly.Msg[`MATH_MODULO_HELPURL`] = `${path}?menu=Operators#math_modulo`

  // math_single
  Blockly.Msg[`MATH_SINGLE_HELPURL`] = `${path}?menu=Operators#math_single`

  // math_trig
  Blockly.Msg[`MATH_TRIG_HELPURL`] = `${path}?menu=Operators#math_trig`

  // math_constant
  Blockly.Msg[`MATH_CONSTANT_HELPURL`] = `${path}?menu=Operators#math_constant`

  // math_number_property
  Blockly.Msg[
    `MATH_NUMBER_PROPERTY_HELPURL`
  ] = `${path}?menu=Operators#math_number_property`

  // math_round
  Blockly.Msg[`MATH_ROUND_HELPURL`] = `${path}?menu=Operators#math_round`

  // math_random_float
  Blockly.Msg[
    `MATH_RANDOM_FLOAT_HELPURL`
  ] = `${path}?menu=Operators#math_random_float`

  // math_on_list
  Blockly.Msg[`MATH_ONLIST_HELPURL`] = `${path}?menu=Operators#math_on_list`

  // math_constrain
  Blockly.Msg[
    `MATH_CONSTRAIN_HELPURL`
  ] = `${path}?menu=Operators#math_constrain`

  // math_atan2
  Blockly.Msg[`MATH_ATAN2_HELPURL`] = `${path}?menu=Operators#math_atan2`

  // 文本、字符串-->类别的积木跳转配置
  // text
  Blockly.Msg[`TEXT_TEXT_HELPURL`] = `${path}?menu=Text#text`

  // text_join
  Blockly.Msg[`TEXT_JOIN_HELPURL`] = `${path}?menu=Text#text_join`

  // text_length
  Blockly.Msg[`TEXT_LENGTH_HELPURL`] = `${path}?menu=Text#text_length`

  // gta_ai_variable_change
  Blockly.Msg[
    `GTA_AI_VARIABLE_CHANGE`
  ] = `${path}?menu=Text#gta_ai_variable_change`

  // gta_ai_variable_change_2
  Blockly.Msg[
    `GTA_AI_VARIABLE_CHANGE_2`
  ] = `${path}?menu=Text#gta_ai_variable_change_2`

  // text_changeCase
  Blockly.Msg[`TEXT_CHANGECASE_HELPURL`] = `${path}?menu=Text#text_changeCase`

  // gta_ai_text_include
  Blockly.Msg[
    `ATA_AI_TEXT_INCLUDE_HELPURL`
  ] = `${path}?menu=Text#gta_ai_text_include`

  // gta_ai_text_include_2
  Blockly.Msg[
    `ATA_AI_TEXT_INCLUDE_2_HELPURL`
  ] = `${path}?menu=Text#gta_ai_text_include_2`

  // text_isEmpty
  Blockly.Msg[`TEXT_ISEMPTY_HELPURL`] = `${path}?menu=Text#text_isEmpty`

  // text_indexOf
  Blockly.Msg[`TEXT_INDEXOF_HELPURL`] = `${path}?menu=Text#text_indexOf`

  // lists_split
  Blockly.Msg[`LISTS_SPLIT_HELPURL`] = `${path}?menu=Text#lists_split`

  // lists_split_1
  Blockly.Msg[`LISTS_SPLIT_1_HELPURL`] = `${path}?menu=Text#lists_split_1`

  // text_getSubstring
  Blockly.Msg[
    `TEXT_GET_SUBSTRING_HELPURL`
  ] = `${path}?menu=Text#text_getSubstring`

  // text_append
  Blockly.Msg[`TEXT_APPEND_HELPURL`] = `${path}?menu=Text#text_append`

  // text_trim
  Blockly.Msg[`TEXT_TRIM_HELPURL`] = `${path}?menu=Text#text_trim`

  // 列表-->类别的积木跳转配置
  // lists_create_with(items=`0`/items=`2`)
  Blockly.Msg[
    `LISTS_CREATE_WITH_HELPURL`
  ] = `${path}?menu=List#lists_create_with`

  // lists_establish_with(items=`0`/items=`2`)
  Blockly.Msg[
    `LISTS_ESTABLISH_WITH_HELPURL`
  ] = `${path}?menu=List#lists_establish_with`

  // lists_setIndex
  Blockly.Msg[`LISTS_SET_INDEX_HELPURL`] = `${path}?menu=List#lists_setIndex`

  // lists_getIndex
  Blockly.Msg[`LISTS_GET_INDEX_HELPURL`] = `${path}?menu=List#lists_getIndex`

  // lists_indexOf
  Blockly.Msg[`LISTS_INDEX_OF_HELPURL`] = `${path}?menu=List#lists_indexOf`

  // lists_length
  Blockly.Msg[`LISTS_LENGTH_HELPURL`] = `${path}?menu=List#lists_length`

  // lists_getSublist
  Blockly.Msg[
    `LISTS_GET_SUBLIST_HELPURL`
  ] = `${path}?menu=List#lists_getSublist`

  // lists_isEmpty
  Blockly.Msg[`LISTS_ISEMPTY_HELPURL`] = `${path}?menu=List#lists_isEmpty`

  // lists_repeat
  Blockly.Msg[`LISTS_REPEAT_HELPURL`] = `${path}?menu=List#lists_repeat`

  // gta_ai_lists_include
  Blockly.Msg[
    `GAT_AI_LISTS_INCLUDE_HELPURL`
  ] = `${path}?menu=List#gta_ai_lists_include`

  // gta_ai_lists_include_2
  Blockly.Msg[
    `GAT_AI_LISTS_INCLUDE_2_HELPURL`
  ] = `${path}?menu=List#gta_ai_lists_include_2`

  // lists_sort
  Blockly.Msg[`LISTS_SORT_HELPURL`] = `${path}?menu=List#lists_sort`

  // 字典-->类别的积木跳转配置
  // create_dict
  Blockly.Msg[`CREATE_DICT_HELPURL`] = `${path}?menu=Dictionary#create_dict`

  // dict_create_with
  Blockly.Msg[
    `DICT_CREATE_WITH_HELPURL`
  ] = `${path}?menu=Dictionary#dict_create_with`

  // set_dict
  Blockly.Msg[`SET_DICT_HELPURL`] = `${path}?menu=Dictionary#set_dict`

  // gta_ai_get_dict_key
  Blockly.Msg[
    `GTA_AI_GET_DICT_HELPURL`
  ] = `${path}?menu=Dictionary#gta_ai_get_dict_key`

  // length_of_dict
  Blockly.Msg[
    `LENGTH_OF_DICT_HELPURL`
  ] = `${path}?menu=Dictionary#length_of_dict`

  // del_dict_key
  Blockly.Msg[`DEL_DICT_KEY_HELPURL`] = `${path}?menu=Dictionary#del_dict_key`

  // del_dict_key_2
  Blockly.Msg[
    `DEL_DICT_KEY_2_HELPURL`
  ] = `${path}?menu=Dictionary#del_dict_key_2`

  // gta_ai_dict_include_2
  Blockly.Msg[
    `GET_AI_DICT_INCLUDE_2_HELPURL`
  ] = `${path}?menu=Dictionary#gta_ai_dict_include_2`

  // gta_ai_dict_include
  Blockly.Msg[
    `GET_AI_DICT_INCLUDE_HELPURL`
  ] = `${path}?menu=Dictionary#gta_ai_dict_include`

  // 变量-->类别的积木跳转配置
  Blockly.Msg[`VARIABLES_SET_HELPURL`] = `${path}?menu=Variable#variables_set`

  Blockly.Msg[`MATH_CHANGE_HELPURL`] = `${path}?menu=Variable#math_change`

  Blockly.Msg[`VARIABLES_GET_HELPURL`] = `${path}?menu=Variable#variables_get`

  // 函数-->类别的积木跳转配置
  Blockly.Msg[
    `PROCEDURES_DEFNORETURN_HELPURL`
  ] = `${path}?menu=Function#procedures_defnoreturn`

  Blockly.Msg[
    `PROCEDURES_DEFRETURN_HELPURL`
  ] = `${path}?menu=Function#procedures_defreturn`

  Blockly.Msg[
    `PROCEDURES_IFRETURN_HELPURL`
  ] = `${path}?menu=Function#procedures_ifreturn`

  Blockly.Msg[`PROCEDURES_CALLNORETURN_HELPURL`] = `${path}?menu=Function#2`

  Blockly.Msg[`PROCEDURES_CALLRETURN_HELPURL`] = `${path}?menu=Function#2`

  // 媒体 --> 音频功能，图片，摄像头
  // upload_audio
  Blockly.Msg[`UPLOAD_AUDIO_HELPURL`] = `${path}?menu=Media#1`

  // play_audio
  Blockly.Msg[`PLAY_AUDIO_HELPURL`] = `${path}?menu=Media#play_audio`

  // pause_audio
  Blockly.Msg[`PAUSE_AUDIO_HELPURL`] = `${path}?menu=Media#pause_audio`

  // volume_add_audio
  Blockly.Msg[
    `VOLUME_ADD_AUDIO_HELPURL`
  ] = `${path}?menu=Media#volume_add_audio`

  // volume_set_audio
  Blockly.Msg[
    `VOLUME_SET_AUDIO_HELPURL`
  ] = `${path}?menu=Media#volume_set_audio`

  // pic_blocks
  Blockly.Msg[`PIC_BLOCKS_HELPURL`] = `${path}?menu=Media#pic_blocks`

  // play_camera
  Blockly.Msg[`PLAY_CAMERA_HELPURL`] = `${path}?menu=Media#play_camera`

  /** 数据库积木 - 通用模型积木*/

  // 我的模型 - MyModel //
  // 植物识别 plant_recognition
  Blockly.Msg[`MY_MODEL_PLANT_RECOGNITION_HELPURL`] = `${path}?menu=MyModel#1`

  // 基础模型 - BasicModel //
  // 物体检测 Object_detection
  Blockly.Msg[
    `BASIC_MODEL_OBJECT_DETECTION_HELPURL`
  ] = `${path}?menu=BasicModel#1`

  // 图像分类 image_classification
  Blockly.Msg[
    `BASIC_MODEL_IMAGE_CLASSIFICATION_HELPURL`
  ] = `${path}?menu=BasicModel#2`

  // 人物识别 character_recognition
  Blockly.Msg[
    `BASIC_MODEL_CHARACTER_RECOGNITION_HELPURL`
  ] = `${path}?menu=BasicModel#3`

  // 语音识别 speech_recognition
  Blockly.Msg[
    `BASIC_MODEL_SPEECH_RECOGNITION_HELPURL`
  ] = `${path}?menu=BasicModel#4`

  // 文字识别 written_words_recognition
  Blockly.Msg[
    `BASIC_MODEL_WRITTEN_WORDS_RECOGNITION_HELPURL`
  ] = `${path}?menu=BasicModel#5`

  // 语音合成 speech_synthesis
  Blockly.Msg[
    `BASIC_MODEL_SPEECH_SYNTHESIS_HELPURL`
  ] = `${path}?menu=BasicModel#6`

  // 进阶模型 - AdvancedModel //
  // 人物识别 - 人脸识别 face_recognition
  Blockly.Msg[
    `ADVANCED_MODEL_FACE_RECOGNITION_HELPURL`
  ] = `${path}?menu=AdvancedModel#1`

  // 人物识别 - 人体分析 human_body_analysis
  Blockly.Msg[
    `ADVANCED_MODEL_HUMAN_BODY_ANALYSIS_HELPURL`
  ] = `${path}?menu=AdvancedModel#2`

  // 智能硬件 - IntelligentHardware //
  // 智能摄像头 smart_camera
  Blockly.Msg[
    `INTELLIGENT_HARDWARE_SMART_CAMERA_HELPURL`
  ] = `${path}?menu=IntelligentHardware#1`

  // 智能机械臂 intelligent_manipulator
  Blockly.Msg[
    `INTELLIGENT_HARDWARE_INTELLIGENT_MANIPULATOR_HELPURL`
  ] = `${path}?menu=IntelligentHardware#2`

  // AGV无人小车 AGV_unmanned_car
  Blockly.Msg[
    `INTELLIGENT_HARDWARE_AGV_UNMANNED_CAR_HELPURL`
  ] = `${path}?menu=IntelligentHardware#3`

  // AI人形机器人 AI_humanoid_robot
  Blockly.Msg[
    `INTELLIGENT_HARDWARE_AI_HUMANOID_ROBOT_HELPURL`
  ] = `${path}?menu=IntelligentHardware#4`

  // 新建积木 - NewBuildingBlocks //
  // New_Building_Blocks
  Blockly.Msg[
    `NEW_BUILDING_BLOCKS_HELPURL`
  ] = `${path}?menu=NewBuildingBlocks#1`

  /**海龟库积木类别*/
  //海龟动作

  Blockly.Msg[
    `gta_turtle_forward`
  ] = `${path}?menu=TurtleMotion#gta_turtle_forward`

  Blockly.Msg[
    `gta_turtle_backward`
  ] = `${path}?menu=TurtleMotion#gta_turtle_backward`

  Blockly.Msg[
    `gta_turtle_rotate`
  ] = `${path}?menu=TurtleMotion#gta_turtle_rotate`

  Blockly.Msg[`gta_turtle_right`] = `${path}?menu=TurtleMotion#gta_turtle_right`

  Blockly.Msg[`gta_turtle_left`] = `${path}?menu=TurtleMotion#gta_turtle_left`

  Blockly.Msg[`gta_turtle_goto`] = `${path}?menu=TurtleMotion#gta_turtle_goto`

  Blockly.Msg[
    `gta_turtle_setx_sety`
  ] = `${path}?menu=TurtleMotion#gta_turtle_setx_sety`

  Blockly.Msg[
    `gta_turtle_setheading`
  ] = `${path}?menu=TurtleMotion#gta_turtle_setheading`

  Blockly.Msg[`gta_turtle_home`] = `${path}?menu=TurtleMotion#gta_turtle_home`

  Blockly.Msg[
    `gta_turtle_circle`
  ] = `${path}?menu=TurtleMotion#gta_turtle_circle`

  Blockly.Msg[`gta_turtle_dot_2`] = `${path}?menu=TurtleMotion#gta_turtle_dot_2`

  Blockly.Msg[
    `gta_turtle_polygon`
  ] = `${path}?menu=TurtleMotion#gta_turtle_polygon`

  Blockly.Msg[`gta_turtle_speed`] = `${path}?menu=TurtleMotion#gta_turtle_speed`

  Blockly.Msg[`gta_turtle_undo`] = `${path}?menu=TurtleMotion#gta_turtle_undo`

  Blockly.Msg[`gta_turtle_reset`] = `${path}?menu=TurtleMotion#gta_turtle_reset`

  Blockly.Msg[`gta_turtle_write`] = `${path}?menu=TurtleMotion#gta_turtle_write`

  Blockly.Msg[`gta_turtle_pan`] = `${path}?menu=TurtleMotion#gta_turtle_pan`

  Blockly.Msg[
    `gta_turtle_towards`
  ] = `${path}?menu=TurtleMotion#gta_turtle_towards`

  Blockly.Msg[`gta_turtle_cor`] = `${path}?menu=TurtleMotion#gta_turtle_cor`

  Blockly.Msg[
    `gta_turtle_heading`
  ] = `${path}?menu=TurtleMotion#gta_turtle_heading`

  Blockly.Msg[
    `gta_turtle_distance`
  ] = `${path}?menu=TurtleMotion#gta_turtle_distance`

  Blockly.Msg[
    `gta_turtle_degrees`
  ] = `${path}?menu=TurtleMotion#gta_turtle_degrees`

  Blockly.Msg[
    `gta_turtle_radians`
  ] = `${path}?menu=TurtleMotion#gta_turtle_radians`

  //   画笔控制
  Blockly.Msg[
    `gta_turtle_pendown`
  ] = `${path}?menu=TurtleControl#gta_turtle_pendown`

  Blockly.Msg[
    `gta_turtle_penup`
  ] = `${path}?menu=TurtleControl#gta_turtle_penup`

  Blockly.Msg[
    `gta_turtle_pensize`
  ] = `${path}?menu=TurtleControl#gta_turtle_pensize`

  Blockly.Msg[
    `gta_turtle_isdown`
  ] = `${path}?menu=TurtleControl#gta_turtle_isdown`

  Blockly.Msg[
    `gta_turtle_color`
  ] = `${path}?menu=TurtleControl#gta_turtle_color`

  Blockly.Msg[
    `gta_turtle_color`
  ] = `${path}?menu=TurtleControl#gta_turtle_color`

  Blockly.Msg[
    `gta_turtle_pencolor`
  ] = `${path}?menu=TurtleControl#gta_turtle_pencolor`

  Blockly.Msg[
    `gta_turtle_fillcolor`
  ] = `${path}?menu=TurtleControl#gta_turtle_fillcolor`

  Blockly.Msg[
    `gta_turtle_filling`
  ] = `${path}?menu=TurtleControl#gta_turtle_filling`

  Blockly.Msg[
    `gta_turtle_begin_end_fill`
  ] = `${path}?menu=TurtleControl#gta_turtle_begin_end_fill`

  //  海龟状态
  Blockly.Msg[
    `gta_turtle_hide_show`
  ] = `${path}?menu=TurtleStatus#gta_turtle_hide_show`

  Blockly.Msg[
    `gta_turtle_isvisible`
  ] = `${path}?menu=TurtleStatus#gta_turtle_isvisible`

  Blockly.Msg[`gta_turtle_shape`] = `${path}?menu=TurtleStatus#gta_turtle_shape`

  Blockly.Msg[
    `gta_turtle_resizemode`
  ] = `${path}?menu=TurtleStatus#gta_turtle_resizemode`

  Blockly.Msg[
    `gta_turtle_shapesize`
  ] = `${path}?menu=TurtleStatus#gta_turtle_shapesize`

  Blockly.Msg[
    `gta_turtle_shearfactor`
  ] = `${path}?menu=TurtleStatus#gta_turtle_shearfactor`

  Blockly.Msg[
    `gta_turtle_settiltangle`
  ] = `${path}?menu=TurtleStatus#gta_turtle_settiltangle`

  Blockly.Msg[`gta_turtle_tilt`] = `${path}?menu=TurtleStatus#gta_turtle_tilt`

  Blockly.Msg[
    `gta_turtle_shapetransform`
  ] = `${path}?menu=TurtleStatus#gta_turtle_shapetransform`

  Blockly.Msg[
    `gta_turtle_get_shapepoly`
  ] = `${path}?menu=TurtleStatus#gta_turtle_get_shapepoly`

  //海龟库窗口

  Blockly.Msg[
    `gta_turtle_bgcolor`
  ] = `${path}?menu=TurtleScreen#gta_turtle_bgcolor`

  Blockly.Msg[
    `gta_turtle_clearscreen`
  ] = `${path}?menu=TurtleScreen#gta_turtle_clearscreen`

  Blockly.Msg[
    `gta_turtle_resetscreen`
  ] = `${path}?menu=TurtleScreen#gta_turtle_resetscreen`

  Blockly.Msg[
    `gta_turtle_screensize`
  ] = `${path}?menu=TurtleScreen#gta_turtle_screensize`

  Blockly.Msg[
    `gta_turtle_setworldcoordinates`
  ] = `${path}?menu=TurtleScreen#gta_turtle_setworldcoordinates`

  Blockly.Msg[`gta_turtle_delay`] = `${path}?menu=TurtleScreen#gta_turtle_delay`

  Blockly.Msg[
    `gta_turtle_set_pan`
  ] = `${path}?menu=TurtleScreen#gta_turtle_set_pan`

  Blockly.Msg[`gta_turtle_stamp`] = `${path}?menu=TurtleScreen#gta_turtle_stamp`

  Blockly.Msg[`gta_turtle_clear`] = `${path}?menu=TurtleScreen#gta_turtle_clear`

  Blockly.Msg[
    `gta_turtle_penup_pendown`
  ] = `${path}?menu=Turtle#gta_turtle_penup_pendown`

  Blockly.Msg[
    `gta_turtle_textinput`
  ] = `${path}?menu=Turtle#gta_turtle_textinput`

  Blockly.Msg[`gta_turtle_numinput`] = `${path}?menu=Turtle#gta_turtle_numinput`

 /**
  * 
  * 小聪编辑器
  * */
 //事件

  Blockly.Msg[`gta_define_robot`] = `${path}?menu=Event#gta_define_robot`

  
  Blockly.Msg[`gta_turn_on_motion`] = `${path}?menu=Event#gta_turn_on_motion`

  //行驶 
  Blockly.Msg[`gta_move_in_open_loop`] = `${path}?menu=Motion#gta_move_in_open_loop`
  Blockly.Msg[`gta_straight_move`] = `${path}?menu=Motion#gta_straight_move`
  Blockly.Msg[`gta_robot_turn`] = `${path}?menu=Motion#gta_robot_turn`
   //灯光
  Blockly.Msg[`gta_set_light_color`] = `${path}?menu=Light#gta_set_light_color`
  Blockly.Msg[`gta_set_light_mode_on`] = `${path}?menu=Light#gta_set_light_mode_on`
  Blockly.Msg[`gta_set_light_mode_blink`] = `${path}?menu=Light#gta_set_light_mode_blink`
  Blockly.Msg[`gta_set_light_mode_breathe`] = `${path}?menu=Light#gta_set_light_mode_breathe`
  Blockly.Msg[`gta_light_on_of`] = `${path}?menu=Light#gta_light_on_of`
  //行驶 
  Blockly.Msg[`gta_forearm_move_in_open_loop`] = `${path}?menu=Posture#gta_forearm_move_in_open_loop`
  Blockly.Msg[`gta_forearm_move`] = `${path}?menu=Posture#gta_forearm_move`
  Blockly.Msg[`gta_arm_move_in_open_loop`] = `${path}?menu=Posture#gta_arm_move_in_open_loop`
  Blockly.Msg[`gta_arm_move`] = `${path}?menu=Posture#gta_arm_move`
  Blockly.Msg[`gta_head_move_in_open_loop`] = `${path}?menu=Posture#gta_head_move_in_open_loop`
  Blockly.Msg[`gta_head_move`] = `${path}?menu=Posture#gta_head_move`
  Blockly.Msg[`gta_paw_move_in_open_loop`] = `${path}?menu=Posture#gta_paw_move_in_open_loop`
  Blockly.Msg[`gta_paw_move`] = `${path}?menu=Posture#gta_paw_move`
  //声音
  Blockly.Msg[`gta_robot_tts`] = `${path}?menu=Voice#gta_robot_tts`
  Blockly.Msg[`gta_robot_play`] = `${path}?menu=Voice#gta_robot_play`
  Blockly.Msg[`gta_get_play_status`] = `${path}?menu=Voice#gta_get_play_status`
  Blockly.Msg[`gta_set_volume`] = `${path}?menu=Voice#gta_set_volume`
  Blockly.Msg[`gta_get_volume`] = `${path}?menu=Voice#gta_get_volume`
  //情感
  Blockly.Msg[`gta_robot_play_emotion_1`] = `${path}?menu=Emotion#gta_robot_play_emotion_1`
  Blockly.Msg[`gta_robot_play_emotion_2`] = `${path}?menu=Emotion#gta_robot_play_emotion_2`
  Blockly.Msg[`gta_robot_play_emotion_3`] = `${path}?menu=Emotion#gta_robot_play_emotion_3`
  Blockly.Msg[`gta_robot_play_emotion_4`] = `${path}?menu=Emotion#gta_robot_play_emotion_4`
  Blockly.Msg[`gta_robot_play_emotion_5`] = `${path}?menu=Emotion#gta_robot_play_emotion_5`
  Blockly.Msg[`gta_robot_play_emotion_6`] = `${path}?menu=Emotion#gta_robot_play_emotion_6`
  Blockly.Msg[`gta_turn_on_expression`] = `${path}?menu=Emotion#gta_turn_on_expression`
  Blockly.Msg[`gta_turn_off_expression`] = `${path}?menu=Emotion#gta_turn_off_expression`
  //显示
  Blockly.Msg[`gta_robot_display_image`] = `${path}?menu=Display#gta_robot_display_image`
  Blockly.Msg[`gta_robot_display_audio`] = `${path}?menu=Display#gta_robot_display_audio`
  Blockly.Msg[`gta_robot_show_camera`] = `${path}?menu=Display#gta_robot_show_camera`
  Blockly.Msg[`gta_robot_stop_showing`] = `${path}?menu=Display#gta_robot_stop_showing`
  // 检测
  Blockly.Msg[`gta_turn_on_cliff_detection`] = `${path}?menu=Detection#gta_turn_on_cliff_detection`
  Blockly.Msg[`gta_turn_off_cliff_detection`] = `${path}?menu=Detection#gta_turn_off_cliff_detection`
  Blockly.Msg[`gta_robot_read_infrared`] = `${path}?menu=Detection#gta_robot_read_infrared`
  Blockly.Msg[`gta_detect_face`] = `${path}?menu=Detection#gta_detect_face`
  Blockly.Msg[`gta_get_face_feature`] = `${path}?menu=Detection#gta_get_face_feature`
  Blockly.Msg[`gta_detect_pattern`] = `${path}?menu=Detection#gta_detect_pattern`
  Blockly.Msg[`gta_get_pattern_location`] = `${path}?menu=Detection#gta_get_pattern_location`
  Blockly.Msg[`gta_read_gyroscope`] = `${path}?menu=Detection#gta_read_gyroscope`
  Blockly.Msg[`gta_read_gyroscope2`] = `${path}?menu=Detection#gta_read_gyroscope2`
  // 摄像头
  Blockly.Msg[`gta_display_video`] = `${path}?menu=Camera#gta_display_video`
  Blockly.Msg[`gta_robot_get_camera_image`] = `${path}?menu=Camera#gta_robot_get_camera_image`
  
  
 
/**
  * 
  * 小智编辑器
  * 
  * */
//事件
 Blockly.Msg[`gta_robot`] = `${path}?menu=Event#gta_robot`
 Blockly.Msg[`gta_define_robot_B`] = `${path}?menu=Event#gta_define_robot_B`
 Blockly.Msg[`gta_robot_B_close`] = `${path}?menu=Event#gta_robot_B_close`
 Blockly.Msg[`gta_robot_B_get_battery`] = `${path}?menu=Event#gta_robot_B_get_battery`
 Blockly.Msg[`gta_robot_B_get_version`] = `${path}?menu=Event#gta_robot_B_get_version`
 
 //行驶
 Blockly.Msg[`gta_robot_B_drive_wheels`] = `${path}?menu=Motion#gta_robot_B_drive_wheels`
 Blockly.Msg[`gta_robot_B_chassis_move`] = `${path}?menu=Motion#gta_robot_B_chassis_move`
  //姿势
 Blockly.Msg[`gta_robot_B_arm_recenter`] = `${path}?menu=Postrue#gta_robot_B_arm_recenter`
 Blockly.Msg[`gta_robot_B_arm_move_to`] = `${path}?menu=Posture#gta_robot_B_arm_move_to`
 Blockly.Msg[`gta_robot_B_gripper_close`] = `${path}?menu=Posture#gta_robot_B_gripper_close`
 Blockly.Msg[`gta_robot_B_gripper_open`] = `${path}?menu=Posture#gta_robot_B_gripper_open`
 Blockly.Msg[`gta_robot_B_servo_move_to`] = `${path}?menu=Posture#gta_robot_B_servo_move_to`
 //灯光
 Blockly.Msg[`gta_robot_B_led_set_led`] = `${path}?menu=Light#gta_robot_B_led_set_led`
 //摄像头
 Blockly.Msg[`gta_robot_B_display_video`] = `${path}?menu=Camera#gta_robot_B_display_video`
 Blockly.Msg[`gta_robot_B_get_camera_image`] = `${path}?menu=Camera#gta_robot_B_get_camera_image`
 //技能
 Blockly.Msg[`gta_robot_B_detect_color_blob`] = `${path}?menu=Skill#gta_robot_B_detect_color_blob`
 Blockly.Msg[`gta_robot_hsv`] = `${path}?menu=Skill#gta_robot_hsv`
 Blockly.Msg[`gta_robot_B_move_along_line`] = `${path}?menu=Skill#gta_robot_B_move_along_line`
 Blockly.Msg[`gta_robot_B_detect_pattern`] = `${path}?menu=Skill#gta_robot_B_detect_pattern`
 Blockly.Msg[`gta_robot_B_move_to_pattern`] = `${path}?menu=Skill#gta_robot_B_move_to_pattern`
 Blockly.Msg[`gta_robot_B_detect_face`] = `${path}?menu=Skill#gta_robot_B_detect_face`
 Blockly.Msg[`gta_robot_B_detect_qrcode`] = `${path}?menu=Skill#gta_robot_B_detect_qrcode`

}
